import { IS_SERVICE_EXPANSION_ENABLED } from 'services/LocationService/constant';

import { ServiceName } from './types';

export const serviceName: ServiceName = IS_SERVICE_EXPANSION_ENABLED ? 'expansion' : 'legacy';

export const MAPPED_LOCATION_TYPE_KEYS = {
  expansion: {
    'emergencyRooms.Locations': 'emergencyRoomsLocations',
    'urgentCares.Locations': 'instacaresLocations',
    'kidsCares.Locations': 'kidscaresLocations'
  },
  legacy: {
    EmergencyRooms: 'emergencyRoomsLocations',
    UrgentCares: 'instacaresLocations',
    KidsCares: 'kidscaresLocations'
  }
};

export const MAPPED_KEYS_FACILITIES_RESPONSE = {
  expansion: {
    'TodaysHours.IsOpen': 'isCurrentlyOpen',
    Id: 'locationId',
    'Thumbnail.Url': 'locationImageUrl',
    Name: 'locationName',
    DistanceToUser: 'distanceToUser',
    'Address.Address1': 'address1',
    CurrentWaitTimeInMinutes: 'currentWaitTime',
    'Contact.MainPhone': 'phone',
    OperatingHours: 'operatingHours'
  },
  legacy: {
    isCurrentlyOpen: 'isCurrentlyOpen',
    locationId: 'locationId',
    locationImageUrl: 'locationImageUrl',
    locationName: 'locationName',
    distanceToUser: 'distanceToUser',
    address1: 'address1',
    currentWaitTime: 'currentWaitTime',
    phone: 'phone',
    operatingHours: 'operatingHours'
  }
};
